import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';

import { HolidayService } from '../services/holidays/holiday.service';
import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';



@Component({
  moduleId: module.id,
  selector: 'my-holidays',
  templateUrl: 'holidays.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class HolidaysComponent extends UsersComponent {


  timezone:string="America/Buenos_Aires"
  date:Date;

  constructor(
    protected router: Router,
    protected holidayService: HolidayService,
    protected providerSevice: ProviderService) { super(router, holidayService,providerSevice); }

  protected getDetailUrl(): string {

    return '/holiday/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'holiday';
  };

  protected getUsersString(): string {

    return 'Holidays';
  };

  ngOnInit(): void {
    this.getUsers({ limit: this.usersPerGet })
}


  alertExist:boolean=false;
  alertConfirm:boolean=false;
  closeAlertConfirm(){
    this.createCalled=false
    this.alertConfirm=false;
  }
  closeAlertExist(){
    this.createCalled=false
    this.alertExist=false;
  }

  pushOrdered(holiday){
    for (let i=0;i<this.users.length;i++){
      if (holiday.dayTime < this.users[i].dayTime){
        this.users.splice(i,0,holiday)
        return;
      }
    }
    this.users.push(holiday)

  }

  finishAdd(){
    this.alertConfirm=false;
    let dateString = this.date.toString()
    dateString = dateString.slice(8,10)+'-'+dateString.slice(5,8)+dateString.slice(0,4)
  
    if (this.holidayExist(dateString)) {
      this.alertExist=true;
      this.createCalled=false
      return;
    }
    this.alertExist=false;
    this.holidayService.create({
      day: dateString,
      timezone:this.timezone
    })
      .then(holiday => {

        this.createCalled = false;
        this.pushOrdered(holiday);
        this.selectedUser = null;
        this.alertCreated=true;
        this.configPages()
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        confirm(error.message)
        return Promise.reject(error.message || error);
      });
  }
  add(): void {
    this.alertConfirm=false;
    this.alertCreated=false;
    this.alertExist=false;

    if (this.createCalled) {      
      return;
    }
    
    if (this.date==undefined) {
      this.alertAdd=true;
      return; 
    }

    this.alertAdd=false;
    this.createCalled = true;
    this.alertConfirm=true;

    
  }

  holidayExist(holiday:string): boolean{
    for (let i=0;i<this.users.length;i++){
      if (holiday.toLowerCase() === this.users[i].day) return true;
    }
    return false;
  }

}


// WEBPACK FOOTER //
// ./src/app/holidays/holidays.component.ts